import spreadsheet from './spreadsheet';

export default spreadsheet;
